import { useEffect } from "react";
import { useAuth } from "../Contexts/AuthContext";

export default function Logout() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    // Hard refresh to clear all application state and memory
    window.location.href = "/";
  }, [logout]);

  return null;
}